export enum AlignmentModel {
  AudioshakeAlignment = "audioshake-alignment",
  AudioshakeTranscription = "audioshake-transcription",
  Custom = "custom",
}

export enum StemSeparationModel {
  Original = "original",
  MDXNetKara2 = "uvr_mdxnet_kara_2",
  MDX23C = "mdx23c",
  MelBandRoformerInstrumentalBecruily = "mel_band_roformer_instrumental_becruily",
  MelBandRoformerInstrumentalInstv7Gabox = "mel_band_roformer_instrumental_instv7_gabox",
}

export enum StemType {
  Original = "original",
  Vocals = "vocals",
  Instrumental = "instrumental",
}

export enum JobStatus {
  Created = "created",
  Queued = "queued",
  InProgress = "in-progress",
  Completed = "completed",
  Failed = "failed",
  Cancelled = "cancelled",
  TimedOut = "timed-out",
}

export enum TaskStatus {
  Created = "created",
  Queued = "queued",
  InProgress = "in-progress",
  Completed = "completed",
  Failed = "failed",
  Cancelled = "cancelled",
  TimedOut = "timed-out",
  Finalized = "finalized",
}

export enum JobProvider {
  Audioshake = "audioshake",
  Runpod = "runpod",
  AWSBatch = "aws-batch",
}

export enum JobType {
  SyncLyrics = "sync-lyrics",
  StemSeparation = "stem-separation",
  GenerateVideo = "generate-video",
  NormalizeAudio = "normalize-audio",
  ExportProject = "export-project",
  RenderVideoWithAudio = "render-video-with-audio",
}

export enum TaskType {
  CreateKaraoke = "create-karaoke",
  SyncLyrics = "sync-lyrics",
  StemSeparation = "stem-separation",
  GenerateVideo = "generate-video",
  ExportProject = "export-project",
}

export type BackgroundMediaType = "video" | "image";

export enum BackgroundMediaEnum {
  Video = "video",
  Image = "image",
}

export enum TransactionTypeEnum {
  Topup = "topup",
  Usage = "usage",
  Refund = "refund",
  Adjustment = "adjustment",
}

export enum VideoType {
  WithOriginalAudio = "with-original-audio",
  WithInstrumentalAudio = "with-instrumental-audio",
  WithoutAudio = "without-audio",
}

export enum CreditTopupReason {
  Subscription = "subscription",
  Order = "order",
  Bonus = "bonus",
  Admin = "admin",
  Refund = "refund",
  Trial = "trial",
  FailedTask = "failed-task",
}
